var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 0.25C3.46875 0.25 0 3.71875 0 8C0 12.2812 3.46875 15.75 7.75 15.75C12.0312 15.75 15.5 12.2812 15.5 8C15.5 3.71875 12.0312 0.25 7.75 0.25ZM7.75 10C6.625 10 5.75 9.125 5.75 8C5.75 6.90625 6.625 6 7.75 6C8.84375 6 9.75 6.90625 9.75 8C9.75 9.125 8.84375 10 7.75 10Z",
    fill: "#9CA6BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatus);
export default __webpack_public_path__ + "static/media/empty-status.677cb306e92fb9523641d74d03c2cea1.svg";
export { ForwardRef as ReactComponent };